const dataStatus = [
    { label: "Aktif", value: "true" },
    { label: "Tidak Aktif", value: "false" },
]

const MENU_USER = {
    dataStatus,
}

export default MENU_USER;